import { toDate, maxTime, minTime } from 'date-fns';

const MAX_DATE = toDate(maxTime);
const MIN_DATE = toDate(minTime);

export { MAX_DATE, MIN_DATE };
//# sourceMappingURL=constants.esm.js.map
